<template>
  <div v-if="showModal" class="side__modal opened">
    <div class="side__modal__content">
      <template v-if="step === 'FIRST'">
        <div class="modal__top">
          <div class="modal__header mb1">
            <h3 class="modal__title mb1">{{ $lang.app.ACCEPT_APPLICATION }}</h3>
            <span class="modal__close" @click="closeModal"><svg viewBox="0 0 20 20" width="20" height="20"><use xlink:href="@/assets/v2/img/sprite.svg#modal__close"></use></svg></span>
          </div>
        </div>

        <Form class="modal__footer"
              ref="firstForm"
              @submit="submitFirst"
              :initial-values="firstForm"
              :validation-schema="firstSchema">
          <div class="input__group input__add__info">
            <label for="appointment-input" class="label">{{ $lang.app.PURPOSE_OF_OBJECT }} <span class="text-red-500">*</span></label>
            <div class="select__wrapper">
              <Field name="appointment" v-slot="{ field, errorMessage }">
                <Multiselect
                    id="appointment-input"
                    :class="{'select--fail': errorMessage }"
                    v-bind="field"
                    v-model="firstForm.appointment"
                    :options="helper.appointmentOptions"
                    :placeholder="$lang.app.SELECT_FROM_OPTIONS"
                    :searchable="true"
                    :noOptionsText="$lang.app.LIST_EMPTY"
                    :noResultsText="$lang.app.NOT_FOUND"
                    :can-clear="false">
                </Multiselect>
                <span v-if="errorMessage" class="input__fail">{{ errorMessage }}</span>
              </Field>
            </div>
          </div>
          <div class="input__group input__add__info">
            <label for="location-category-input" class="label">{{ $lang.app.OBJECT_CATEGORY }} <span class="text-red-500">*</span></label>
            <div class="select__wrapper">
              <Field name="locationCategory" v-slot="{ field, errorMessage }">
                <Multiselect
                    id="location-category-input"
                    :class="{'select--fail': errorMessage }"
                    v-bind="field"
                    v-model="firstForm.locationCategory"
                    :options="helper.locationCategoryOptions"
                    :placeholder="$lang.app.SELECT_FROM_OPTIONS"
                    :searchable="true"
                    :noOptionsText="$lang.app.LIST_EMPTY"
                    :noResultsText="$lang.app.NOT_FOUND"
                    :can-clear="false">
                </Multiselect>
                <span v-if="errorMessage" class="input__fail">{{ errorMessage }}</span>
              </Field>
            </div>
          </div>
          <div class="input__group input__add__info">
            <label for="location-type-input" class="label">{{ $lang.app.OBJECT_TYPE }} <span class="text-red-500">*</span></label>
            <div class="select__wrapper">
              <Field name="locationType" v-slot="{ field, errorMessage }">
                <Multiselect
                    id="location-type-input"
                    :class="{'select--fail': errorMessage }"
                    v-bind="field"
                    v-model="firstForm.locationType"
                    :options="helper.locationTypeOptions"
                    :placeholder="$lang.app.SELECT_FROM_OPTIONS"
                    :searchable="true"
                    :noOptionsText="$lang.app.LIST_EMPTY"
                    :noResultsText="$lang.app.NOT_FOUND"
                    :can-clear="false">
                </Multiselect>
                <span v-if="errorMessage" class="input__fail">{{ errorMessage }}</span>
              </Field>
            </div>
          </div>
          <div class="input__group input__checkbox">
            <Field name="isStrategic" v-slot="{ field, errorMessage }">
              <input v-bind="field"
                     type="checkbox"
                     id="is-strategic-input"
                     v-model="firstForm.isStrategic"
                     class="checkbox"
                     :class="{'input--fail': errorMessage }"
                     :value="true">
              <span v-if="errorMessage" class="input__fail">{{ errorMessage }}</span>
            </Field>
            <label for="is-strategic-input" class="label">{{ $lang.app.OBJECT_IS_STRATEGIC }}?</label>
          </div>
          <div class="input__group">
            <label for="agreement-deadline-input" class="label">{{ $lang.app.AGREEMENT_DEADLINE }} <span class="text-red-500">*</span></label>
            <Field name="agreementDeadline" v-slot="{ field, errorMessage }">
              <input v-bind="field"
                     type="date"
                     id="agreement-deadline-input"
                     v-model="firstForm.agreementDeadline"
                     class="input"
                     :min="$moment().format('YYYY-MM-DD')"
                     :class="{'input--fail': errorMessage }"
                     :placeholder="$lang.app.ENTER">
              <span v-if="errorMessage" class="input__fail">{{ errorMessage }}</span>
            </Field>
          </div>
          <div class="input__group">
            <label for="deadline-input" class="label">{{ $lang.app.EXPERTIZE_DEADLINE }} <span class="text-red-500">*</span></label>
            <Field name="deadline" v-slot="{ field, errorMessage }">
              <input v-bind="field"
                     type="date"
                     id="deadline-input"
                     v-model="firstForm.deadline"
                     class="input"
                     :min="$moment().format('YYYY-MM-DD')"
                     :class="{'input--fail': errorMessage }"
                     :placeholder="$lang.app.ENTER">
              <span v-if="errorMessage" class="input__fail">{{ errorMessage }}</span>
            </Field>
          </div>

          <div class="between__buttons">
            <button type="button" class="button button__modal__close button--cancel"
                    @click="closeModal">{{ $lang.app.CANCEL }}</button>
            <button type="submit" class="button button__modal__close">{{ this.$lang.app.NEXT }}</button>
          </div>
        </Form>
      </template>
      <template v-if="step === 'SECOND'">
        <div class="modal__top">
          <div class="modal__header mb1">
            <button type="button" class="button__back" @click="step = 'FIRST'">
              <svg class="button__icon icon" viewBox="0 0 24 24" width="24" height="24">
                <use xlink:href="@/assets/v2/img/sprite.svg#chevron__left"></use>
              </svg>
              {{ $lang.app.BACK }}
            </button>
            <span class="modal__close" @click="closeModal"><svg viewBox="0 0 20 20" width="20" height="20"><use xlink:href="@/assets/v2/img/sprite.svg#modal__close"></use></svg></span>
          </div>
          <h3 class="modal__title mb1">Добавление исполнителей к заявлению</h3>
        </div>

        <Form ref="secondForm"
              @submit="submit"
              class="modal__footer">
          <div class="input__group input__add__info">
            <label for="state-input" class="label">{{ $lang.app.SUBDIVISION }}</label>
            <div class="select__wrapper">
              <Field name="state" v-slot="{ field, errorMessage }">
                <Multiselect
                    id="state-input"
                    :class="{'select--fail': errorMessage }"
                    v-bind="field"
                    v-model="state"
                    :options="helper.stateOptions"
                    :placeholder="$lang.app.SELECT_FROM_OPTIONS"
                    :searchable="true"
                    :noOptionsText="$lang.app.LIST_EMPTY"
                    :noResultsText="$lang.app.NOT_FOUND"
                    :can-clear="false">
                </Multiselect>
                <span v-if="errorMessage" class="input__fail">{{ errorMessage }}</span>
              </Field>
            </div>
          </div>
          <div class="input__group input__add__info">
            <label for="department-input" class="label">{{ $lang.app.DEPARTMENT }}</label>
            <div class="select__wrapper">
              <Field name="department" v-slot="{ field, errorMessage }">
                <Multiselect
                    id="department-input"
                    :class="{'select--fail': errorMessage }"
                    v-bind="field"
                    v-model="department"
                    :options="helper.departmentOptions"
                    :placeholder="$lang.app.SELECT_FROM_OPTIONS"
                    :searchable="true"
                    :noOptionsText="$lang.app.LIST_EMPTY"
                    :noResultsText="$lang.app.NOT_FOUND"
                    :can-clear="false">
                </Multiselect>
                <span v-if="errorMessage" class="input__fail">{{ errorMessage }}</span>
              </Field>
            </div>
          </div>

          <ExecutorsMultiselect
              v-if="helper.employeeOptions.length || form.employees.length"
              :value="form.employees"
              :with-responsible="true"
              @update="form.employees = $event"
              :options="helper.employeeOptions"/>
          <div v-if="errorMessage" class="text-sm text-red-500">{{ errorMessage }}</div>

          <div class="between__buttons">
            <button type="button" @click="closeModal"
                    class="button button__modal__close button--cancel">{{ $lang.app.CANCEL }}</button>
            <button type="submit" class="relative button button__modal__close"
                    :disabled="submitting">
              <svg class="icon" viewBox="0 0 24 24" width="24" height="24">
                <use xlink:href="@/assets/v2/img/sprite.svg#icon__check"></use>
              </svg>
              {{ this.$lang.app.ACCEPT }}
              <div v-if="submitting" class="loading-blue text-white absolute z-10 w-full rounded-lg h-full top-0 left-0 flex items-center justify-center">
                <div class="block animate-spin">
                  <RefreshIcon class="w-6 h-6 mirror-y"/>
                </div>
              </div>
            </button>
          </div>
        </Form>
      </template>

    </div>
  </div>
</template>
<script>
import {Field, Form} from 'vee-validate'

import stateApi from "../../../../api/employee/state"
import employeeApi from "../../../../api/employee/employee"

import ExecutorsMultiselect from "../inputs/ExecutorsMultiselect"
import {getValueByKey as executorTypesGetValue} from "../../../../helpers/constants/executorTypes"
import applicationApi from "../../../../api/employee/application";
import * as yup from "yup";
import locationApi from "../../../../api/ref/location";
import appointmentApi from "@/api/ref/appointment";

export default {
  components: {
    Field,
    Form,
    ExecutorsMultiselect
  },
  data() {
    return {
      showModal: false,
      application: null,

      step: 'FIRST',

      firstForm: {
        appointment: null,
        locationCategory: null,
        locationType: null,
        isStrategic: null,
        deadline: null,
        agreementDeadline: null,
      },

      firstSchema: yup.object({
        appointment: yup.mixed().required(),
        locationCategory: yup.mixed().required(),
        locationType: yup.mixed().required(),
        deadline: yup.mixed().required(),
        agreementDeadline: yup.mixed().required(),
      }),

      submitting: false,

      state: null,
      department: null,
      form: {
        employees: [],
      },
      helper: {
        appointmentOptions: [],
        locationCategoryOptions: [],
        locationTypeOptions: [],
        stateOptions: [],
        departmentOptions: [],
        employeeOptions: [],
      },
      errorMessage: null,
    };
  },
  watch: {
    'firstForm.locationCategory'(value) {
      if (value) {
        this.firstForm.locationType = null
        this.setLocationTypeOptions(value)
      }
    },
    'state'(value) {
      if (value) {
        this.department = null
        this.setDepartmentOptions(value)
      }
    },
    'department'(value) {
      this.helper.employeeOptions = []
      if (value) {
        employeeApi.getEmployeesByDepartmentId(value).then((res) => {
          this.helper.employeeOptions = res.data?.map((item) => ({
            id: item.id,
            name: item.fullName,
            position: this.$lang.$translate({ru: item.position.nameRu, kg: item.position.nameKg}),
            type: this.executorTypesGetValue('EXECUTOR'),
            vacation: item.activeVacation,
          }));
        });
      }
    }
  },
  methods: {
    openModal() {
      this.showModal = true
      this.$emitter.emit('body-unscrollable')
    },
    closeModal() {
      this.showModal = false
      this.$emitter.emit('body-scrollable')
    },
    executorTypesGetValue,
    initAppointmentOptions(){
      appointmentApi.getAppointments().then(res => {
        this.helper.appointmentOptions = res.map(item => ({
          value: item.id,
          label: this.$lang.$translate({ru: item.nameRu, kg: item.nameKg}),
        }))
      })
    },
    initLocationCategoryOptions() {
      locationApi.getLocationCategories().then(res => {
        this.helper.locationCategoryOptions = res.map(item => ({
          value: item.id,
          label: this.$lang.$translate({ru: item.nameRu, kg: item.nameKg}),
        }))
      })
    },
    setLocationTypeOptions(locationCategoryId) {
      locationApi.getLocationTypes(locationCategoryId).then(res => {
        this.helper.locationTypeOptions = res.map(item => ({
          value: item.id,
          label: this.$lang.$translate({ru: item.nameRu, kg: item.nameKg}),
        }))
      })
    },
    initStateOptions() {
      stateApi.getStatesWithDefaultSelections().then((res) => {
        this.helper.stateOptions = res.map(stateItem => ({
          value: stateItem.id,
          label: this.$lang.$translate({ru: stateItem.nameRu, kg: stateItem.nameKg}),
          departments: stateItem.departments.map(departmentItem => ({
            value: departmentItem.id,
            label: this.$lang.$translate({ru: departmentItem.nameRu, kg: departmentItem.nameKg}),
            selected: departmentItem.selected
          })),
          selected: stateItem.selected
        }))
        this.state = this.helper.stateOptions.find(item => item.selected)?.value
      })
    },
    setDepartmentOptions(value) {
      this.helper.departmentOptions = this.helper.stateOptions.find(item => item.value === value)?.departments
      this.department = this.helper.departmentOptions.find(item => item.selected)?.value
    },
    valid() {
      this.errorMessage = null
      if(!this.form.employees.some(e => e.type === this.executorTypesGetValue('RESPONSIBLE'))) {
        this.errorMessage = this.$lang.app.ASSIGN_RESPONSIBLE
        return false
      }
      return true
    },
    submitFirst() {
      this.step = 'SECOND'
    },
    submit() {
      if(this.valid()) {
        this.submitting = true
        applicationApi
            .acceptApplication(this.application.id,
                {
                  appointment: this.firstForm.appointment,
                  deadline: this.firstForm.deadline,
                  agreementDeadline: this.firstForm.agreementDeadline,
                  isStrategic: this.firstForm.isStrategic,
                  locationType: this.firstForm.locationType,
                  userEmployments: this.form.employees.map(employee => ({
                    employment: employee.id,
                    type: employee.type
                  })),
                }
            )
            .then(() => {
              this.closeModal()
              this.$router.push({
                name: 'EmployeeApplicationResolutions',
                params: { applicationId: this.application.id }
              })
              this.$emitter.emit('refreshStatistics')
              this.$emitter.emit('refresh-application', {reload: false})
              this.$emitter.emit('refresh-resolutions', {reload: false})
              this.$snotify.success(this.$lang.app.SUCCESS_ACTION)
            }).catch(error => {
              if(error.response.status === 422) {
                if(error.response.data.errors.agreement
                    || error.response.data.errors.agreementDeadline
                    || error.response.data.errors.locationType) {
                  this.step = 'FIRST'

                  this.$nextTick(() => {
                    this.setValidationErrors(this.$refs.firstForm, error.response.data.errors)
                  })
                }
              } else {
                this.$snotify.error(error.response.data.message)
              }
            }).finally(() => {
              this.submitting = false
            })
      }
    },
  },
  beforeMount() {
    this.$emitter.on('openApplicationAcceptModal', application => {
      this.openModal()
      this.application = application
      this.initAppointmentOptions()
      this.initLocationCategoryOptions()
      this.initStateOptions()
    })
  },
  beforeUnmount() {
    this.$emitter.off('openApplicationAcceptModal')
  }
}
</script>
